export const Ornament = ({ className = "" }) => (
  <div className={`flex items-center gap-4 ${className}`} aria-hidden="true">
    <span className="h-px flex-1 bg-gradient-to-r from-transparent via-amber-500/40 to-amber-500/60" />
    <span className="text-amber-400/70 text-xs">{"\u25C8"}</span>
    <span className="h-px flex-1 bg-gradient-to-l from-transparent via-amber-500/40 to-amber-500/60" />
  </div>
);
